import classNames from "classnames";
import React from "react";
import Modal from "react-modal";

import styles from "./style.module.scss";

const DeleteModal = ({ id, setId, handleDelete, content, showDeleteText = false }) => {
  return (
    <Modal
      isOpen={!!id}
      ariaHideApp={false}
      onAfterOpen={null}
      onRequestClose={null}
      contentLabel="Filter Modal"
      portalClassName="react-modal"
      overlayClassName={classNames("modal", styles.overlayContainer)}
      shouldCloseOnOverlayClick={false}
      className="modal-dialog react-modal-dialog-sm modal-dialog-centered filter-modal custom-small-modal"
    >
      <div className={styles.container}>
        <div className={styles.contentContainer}>{content}</div>
        <div className={styles.footerContainer}>
          <button type="button" onClick={() => setId(null)} className={styles.closeCta}>
            Close{" "}
          </button>
          <button type="button" onClick={() => handleDelete(id)} className={styles.deleteCta}>
            {showDeleteText ? "Delete" : "Yes, Remove"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
